import { ReactComponent as LikeLineIconSvg } from "../../icons/like.shape.svg";

export default function LikeShapeIcon({color="#5C3DFA", ...props}){
  return(
    <LikeLineIconSvg width={"28px"} height={"28px"} fill={color} {...props}/>
  )
}

